import React from 'react'
import { withMicrocopy } from '~contexts/MicrocopyContext'
import { OutboundLink } from "gatsby-plugin-gtag"
import Card from '../Card/Card.component'
import * as style from './CardList.module.scss'
import inconNoResults from '../icons/noResults.svg'

const CardList = ({ samples, microcopy }) => (
  <section>
    {samples.length > 0
            && (
            <div className={style.cardList}>
              {samples.map((sample, id) => (
                <div key={id}>
                  <Card sample={sample} />
                </div>
              ))}
            </div>
            )}
    {samples.length === 0
            && (
            <div className={style.cardList_noResults}>
              <img alt="" src={inconNoResults} />
              <h2>
                {microcopy.text("sample_code_catalog.noResults.title")}
              </h2>
              <p>
                {microcopy.text("sample_code_catalog.noResults.message")}
                {' '}
&nbsp;
                <OutboundLink
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://support.box.com/hc/en-us/community/topics/360001932973-Platform-and-Developer-Forum"
                >
                  {microcopy.text("sample_code_catalog.noResults.link")}
                </OutboundLink>
                {microcopy.text("sample_code_catalog.noResults.suggestSample")}
              </p>
            </div>
            )}
  </section>
)

export default withMicrocopy(CardList)
